import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'

import { getFirebase } from '~/firebase'
import { BootcampGymsListUserData } from '~/types/bootcamp'

import { bootcampSplitApi } from './split.api'

const GetList = bootcampSplitApi.injectEndpoints({
  endpoints: (build) => ({
    // User bootcamp list data from firestore
    getBootcampListUserData: build.query<BootcampGymsListUserData[], { gymCategory?: string; userId?: number }>({
      queryFn: async ({ gymCategory, userId }) => {
        try {
          const { getDocs, query, fireStore, collection, where } = await getFirebase()
          const userBootcampRef =
            userId && userId > 0
              ? getDocs(
                  query(
                    collection(fireStore, 'bootcamp', String(userId), 'progress'),
                    where('gymType', '==', gymCategory),
                  ),
                )
              : null

          const userData = await userBootcampRef

          const processedData = userData
            ? userData.docs.map((item) => {
                const page = item.data()
                return {
                  moduleId: page.moduleId,
                  key: page.bootcampId,
                  chests: (page.green ?? 0) + (page.red ?? 0) + (page.blue ?? 0),
                  bossDefeated: page.quiz > 0,
                }
              })
            : []
          return {
            data: processedData ?? ([] as BootcampGymsListUserData[]),
          }
        } catch (error) {
          return {
            error: error as FetchBaseQueryError,
          }
        }
      },
      providesTags: ['List User Data'],
    }),
    // Total chests earned in every gym
    getUserChestsInGym: build.query<Record<string, number>, { userId?: number }>({
      queryFn: async ({ userId }) => {
        try {
          const { getDocs, query, fireStore, collection } = await getFirebase()
          const userEarnedChestsInGyms =
            userId && userId > 0 ? getDocs(query(collection(fireStore, 'bootcamp', String(userId), 'progress'))) : null

          const userData = await userEarnedChestsInGyms

          const totalChestsInGym: Record<string, number> = {}

          if (userData) {
            userData.docs.forEach((item) => {
              const page = item.data()
              const key = page.bootcampId

              const chests = (page.green ?? 0) + (page.red ?? 0) + (page.blue ?? 0)

              const currentChestsInObj = totalChestsInGym[key] || 0

              totalChestsInGym[key] = currentChestsInObj + chests
            })
          }

          return {
            data: totalChestsInGym,
          }
        } catch (error) {
          return {
            error: error as FetchBaseQueryError,
          }
        }
      },
      providesTags: ['Earned chests in every gym'],
    }),
  }),
  overrideExisting: false,
})

export const { useGetBootcampListUserDataQuery, useGetUserChestsInGymQuery } = GetList
